import { render } from "./Steps2.vue?vue&type=template&id=67ed05f4"
import script from "./Steps2.vue?vue&type=script&lang=js"
export * from "./Steps2.vue?vue&type=script&lang=js"
script.render = render

export default script